export default function doesContainerMatchToShippingMethod(container, shippingMethod) {
    if (!container || !shippingMethod) {
        return false
    }

    if (!container.shippingMethods || container.shippingMethods.length === 0) {
        return false
    }

    return container.shippingMethods.some(sm => sm.id === shippingMethod.id)
}